import { render, staticRenderFns } from "./RegisterStepForm.vue?vue&type=template&id=0d639823&scoped=true&"
import script from "./RegisterStepForm.vue?vue&type=script&lang=js&"
export * from "./RegisterStepForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStepForm.vue?vue&type=style&index=0&id=0d639823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d639823",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d639823')) {
      api.createRecord('0d639823', component.options)
    } else {
      api.reload('0d639823', component.options)
    }
    module.hot.accept("./RegisterStepForm.vue?vue&type=template&id=0d639823&scoped=true&", function () {
      api.rerender('0d639823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RegisterStepForm.vue"
export default component.exports